// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "content_batch".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { contentBatchStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "content_batch" table (1:1 with a DB row, on the wire). */
export const contentBatchAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    periodMonth: z.string(),
    status: z.enum(contentBatchStatusValues),
    errorMessage: z.string().nullable(),
    finaliseAt: z.string().datetime().nullable(),
    reviewedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=contentBatch.js.map